import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult, ErrorData, errorResult } from '@synergy/api';
import { Dispatch } from 'redux';
import { FormikErrors } from 'formik';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { ProductDetail } from '../models/product-detail';
import { ProductDetailOverviewFormValues } from '../models/product-detail-overview-form-values';
import { productDetailOverviewRequestSelector } from './product-detail-overview-selectors';
import { resourceMissing } from '../../../../../../common/reducers/resource-missing-reducer';

export const PRODUCT_DETAIL_OVERVIEW_FETCH = 'PRODUCT_DETAIL_OVERVIEW_FETCH';
export const PRODUCT_DETAIL_OVERVIEW_UPDATE = 'PRODUCT_DETAIL_OVERVIEW_UPDATE';
export const PRODUCT_DETAIL_OVERVIEW_SAVE = 'PRODUCT_DETAIL_OVERVIEW_SAVE';
export const PRODUCT_DETAIL_OVERVIEW_RECEIVE = 'PRODUCT_DETAIL_OVERVIEW_RECEIVE';
export const PRODUCT_DETAIL_OVERVIEW_ERROR = 'PRODUCT_DETAIL_OVERVIEW_ERROR';

const error = (errorData?: ErrorData) => ({
    type: PRODUCT_DETAIL_OVERVIEW_ERROR,
    errorData,
});

const receiveDetail = (productDetail: ProductDetail) => ({
    type: PRODUCT_DETAIL_OVERVIEW_RECEIVE,
    productDetail,
});

export const updateProductDetail = (
    formData: ProductDetailOverviewFormValues,
    isDirty: boolean,
    isValid: boolean,
    errors: FormikErrors<ProductDetailOverviewFormValues>
) => {
    return {
        type: PRODUCT_DETAIL_OVERVIEW_UPDATE,
        formData,
        isDirty,
        isValid,
        errors,
    };
};

export const saveProductDetail = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_OVERVIEW_SAVE });
        const request = productDetailOverviewRequestSelector(getState());
        if (!request) {
            return errorResult();
        }
        const productId = getState().product.detail.overview.productDetail?.id;

        let response: ApiResult<ProductDetail>;
        if (productId) {
            response = await api.product.detail.overview.patchDetail(productId, request);
        } else {
            response = await api.product.detail.overview.createDetail(request);
        }
        if (response.success) {
            dispatch(receiveDetail(response.result));
        } else {
            dispatch(error(response.error));
        }
        return response;
    };
};

export const fetchProductDetail = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_OVERVIEW_FETCH });

        const response = await api.product.detail.overview.getDetail(id);
        if (response.success) {
            dispatch(receiveDetail(response.result));
        } else if (404 === response.errorCode) {
            // Not a fault to report in passing: the address names a record
            // that does not exist, and the mask says so instead of standing empty.
            dispatch(resourceMissing());
        } else {
            dispatch(error(response.error));
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
